<script>
export default {
  name: 'logout',
  beforeRouteEnter(to, from, next) {
    localStorage.removeItem('tokenId');
    localStorage.removeItem('authToken');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('pixelLastNotification');
    next({ name: 'login' });
  }
};
</script>
